export default __webpack_public_path__ + "85cf06b9acd3225c420c5dcf66720f48.mp3";